import script from "./pluginHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./pluginHeader.vue?vue&type=script&setup=true&lang=js"

import "./pluginHeader.vue?vue&type=style&index=0&id=40dd285c&lang=scss"

const __exports__ = script;

export default __exports__